// Live viewers chip (<live-viewers>), the "90 ao vivo" above the rating on
// the product page (blocks/product-live-viewers.liquid).
//
// The number is DECORATIVE, at the client's request (temp/pdp-plan.md,
// decision 2): each page view draws one whole number between the block's
// minimum and maximum. Nothing here measures real traffic.
//
// Drawn once and then left alone. A number that kept changing would be
// auto-updating content (WCAG 2.2.2), owing a pause control; and it is
// never a live region, so a screen reader reads it where it stands and is
// never interrupted by it.
//
// The chip arrives with a `pending` attribute that keeps it invisible but
// in place: its space is reserved from the first paint, so revealing it
// shifts nothing. Without JavaScript it simply stays invisible.

class LiveViewers extends HTMLElement {
  connectedCallback() {
    const count = this.querySelector('[data-live-viewers-count]');
    const first = Number.parseInt(this.dataset.min, 10);
    const second = Number.parseInt(this.dataset.max, 10);
    if (!count || Number.isNaN(first) || Number.isNaN(second)) return;

    // The editor lets the merchant cross the two sliders: order them here
    // instead of drawing from an empty range. "0 ao vivo" is never drawn.
    const min = Math.max(1, Math.min(first, second));
    const max = Math.max(first, second);
    if (max < min) return;

    count.textContent = String(min + Math.floor(Math.random() * (max - min + 1)));
    this.removeAttribute('pending');
  }
}

if (!customElements.get('live-viewers')) {
  customElements.define('live-viewers', LiveViewers);
}
